import styled from "styled-components";

export const Content = styled.div`
  padding: 30px;
  margin-top: 100px;
  width: 100%;
  background-color: #f5f5f5;
`;

export const Title = styled.h1`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
  color: #00000099;
`;

export const Description = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
  color: #00000099;
`;

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  height: 80vh;
  padding: 16px;
`;

export const Header = styled.div`
  display: flex;
  gap: 12px;
`;

export const Body = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
`;

export const ButtonFilter = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #d5deff;
  color: #2d5bff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  //styleName: XS/Regular;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
  letter-spacing: -0.01em;
  text-align: left;
  font-variation-settings: "slnt" 0;
`;

export const ButtonClearFilter = styled.button`
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 36px;
  height: 36px;
  cursor: pointer;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const ButtonExport = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 36px;
  height: 36px;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
